export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const registerFailure = error => ({
    type: REGISTER_FAILURE,
    payload: error,
    error: true,
});
